var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("./../helpers/xmlToJson")

function ActiveServiceTransactionsWS(viewModel) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  this.firstLoad = true;
  this.name = 'ActiveServiceTransactionsWS';			// Convenience name for debugging

  this.activeTransactions = ko.observableArray([]);
  this.allTransactions = ko.observableArray([]);
  this.transactions = ko.observableArray([]);

  this.transactionId = null;


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/serviceTransactions/active';
  });


  /**
   * Ensures that the spot in a transaction is actually a SpotModel
   * 
   * @method buildTransaction
   * @param {JSON} trans 
   * @returns {JSON}
   */
  this.buildTransaction = function (trans) {
    if (trans) {
      var o = {};
      for (var prop in trans) {
        if (Object.prototype.hasOwnProperty.call(trans, prop)) {
          o[prop] = trans[prop];
        }
      }

      // read the spot model from the serviceTransaction, or start with a new SpotModel
      var spot = (o.spot) ? new SpotModel(o.spot) : new SpotModel();

      // If there was no spot in the service transaction, decipher the properties
      if (!o.spot) {
        if (o.phone) {
          spot.phone = o.phone;
        }

        if (o.partySize) {
          spot.partySize = o.partySize;
        }

        if (o.name) {
          var name = "";

          // NOTE: CEC's XML parsing converts values that are digits only as `Number`. 
          // This causes a problem if a Consumer's Name only contains digits because
          // we can't call `split` on a Number. 
          //
          // Here we check if we have a string, or if we can convert to string, to 
          // operate on the name.
          if (typeof o.name == "string") {
            name = o.name;
          }
          else if (o.name.toString) {
            name = o.name.toString();
          }

          spot.merchantInfoName = name;

          var names = name.split(" ")
          if (names.length >= 1) {
            spot.firstName = names[0]
            spot.lastName = (names.length > 1) ? (names.slice(1).join(" ")) : ""
          }
        }

        if (o.queueId) {
          var q = self.parent.queuesWS.getQueueById(o.queueId);

          spot.queueId = o.queueId;

          if (q) {
            spot.queue = ko.observable(q);
            spot.queueName = q.description;
          }
        }

        if (o.sessionId) {
          spot.sessionId = o.sessionId;
        }

        if (o.transactionId) {
          spot.transactionId = o.transactionId;
        }

        if (o.start) {
          spot.start = o.start;
        }
      }

      o.spot = spot;
    }
    return o;
  }


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {ActiveServiceTransactionsWS}
	 */
  self.processData = function (xmlData) {
    var json = null
    var transaction = null
    var serviceTransactions = []

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Only run the following block the first time this dataset is loaded.
    // This is to show "Now serving" for an active service transaction, or
    // open the Arrived list, when the application is first loaded.
    // if ( self.firstLoad ) {
    json = xmlToJson.parse(xmlData);

    // Remove any existing spots
    serviceTransactions = (json.serviceTransactions && json.serviceTransactions.serviceTransaction) ? Array.makeArray(json.serviceTransactions.serviceTransaction) : [];

    if (serviceTransactions.length === 0 && self.transactions().length === 0) {
      return;
    }

    self.activeTransactions.removeAll();
    self.allTransactions.removeAll();
    self.transactions.removeAll();

    if (serviceTransactions.length > 0) {

      /**
       * @type {Array<Object>}
       */
      var allTransactions = serviceTransactions.map(self.buildTransaction)
      self.allTransactions(allTransactions);

      // Put active transaction into the array
      var activeTransactions = allTransactions.filter(function(trans) {
        return !trans.expirationDate
      })
      self.activeTransactions(activeTransactions);

      if (self.parent.allowParallelServiceTransactions()) {
        var transactions = allTransactions.filter(function (trans) {
          return self.parent.queueIds().indexOf(trans.queueId) > -1 && !trans.expirationDate
        })

        // Set the local observable array to the spots array
        self.transactions(transactions);
      }
      else {
        transaction = allTransactions.find(function (trans) {
          return self.parent.queueIds().indexOf(trans.queueId) > -1;
        });


        if (transaction) {
          self.transactions([transaction]);
        }
        else if (self.callback != null) {
          // 				callback.execute(callbackArg);
        }
      }
    }
    else if (!self.parent.allowParallelServiceTransactions()) {
      // 		if ( callback != null ) {
      // 			callback.execute(callbackArg);
      // 		}
      // 		else {
      // 			endServiceTransaction.closeUp();
      // 		}
    }
    // }

    self.firstLoad = false;

    return self;
  };

  return self;
};

Object.setPrototypeOf(ActiveServiceTransactionsWS.prototype, AbstractWS.prototype);

/**
 * 
 * @param {string} sessionId 
 * @returns {object|undefined} returns an object representing a Service Transaction or undefined if a transaction was not found.
 */
ActiveServiceTransactionsWS.prototype.findTransaction = function (sessionId) {
  return this.transactions().find(function (transaction) {
    return transaction.spot.sessionId == sessionId
  })
}


module.exports = ActiveServiceTransactionsWS
